export default {"align-center":"KKs7f"};